// Fonts for the print/preview iframes. The iframe doesn't inherit the app's
// stylesheets, so @font-face rules are injected with absolute URLs to the
// font files the app already ships in /public/font.

function url(file) {
  return window.location.origin + '/font/' + encodeURIComponent(file).replace(/%2F/g, '/');
}

export var FONTS = [
  {
    id: 'vazirmatn',
    label: 'Vazirmatn',
    family: "'PmVazirmatn', Tahoma, sans-serif",
    faces: [
      ['PmVazirmatn', 400, 'Vazirmatn-Regular.woff2', 'woff2'],
      ['PmVazirmatn', 600, 'Vazirmatn-SemiBold.woff2', 'woff2'],
      ['PmVazirmatn', 700, 'Vazirmatn-Bold.woff2', 'woff2'],
    ],
  },
  {
    id: 'iransans',
    label: 'IRANSans',
    family: "'PmIRANSans', Tahoma, sans-serif",
    faces: [
      ['PmIRANSans', 400, 'IRANSans(FaNum).ttf', 'truetype'],
      ['PmIRANSans', 600, 'IRANSans(FaNum)_Medium.ttf', 'truetype'],
      ['PmIRANSans', 700, 'IRANSans(FaNum)_Bold.ttf', 'truetype'],
    ],
  },
  {
    id: 'yekanbakh',
    label: 'Yekan Bakh',
    family: "'PmYekanBakh', Tahoma, sans-serif",
    faces: [['PmYekanBakh', 400, 'YekanBakhFaNum-Regular.ttf', 'truetype']],
  },
  { id: 'tahoma', label: 'Tahoma', family: 'Tahoma, sans-serif', faces: [] },
];

export function fontById(id) {
  return FONTS.find(function (f) { return f.id === id; }) || FONTS[0];
}

export function fontFaceCss(id) {
  return fontById(id).faces.map(function (f) {
    return "@font-face{font-family:'" + f[0] + "';font-weight:" + f[1] +
      ";font-style:normal;font-display:block;src:url('" + url(f[2]) + "') format('" + f[3] + "')}";
  }).join('\n');
}
